export default __webpack_public_path__ + "alberta-gender.8d00856b57b3693e5167.svg";